import type { MutableRefObject } from 'react';
import { L } from '../../../../utils/logger';
import { tagNode } from './diag';

export function makeTransportGate(refs: any) {
  // Reuse if already built
  const cached = (refs as any)._gateFns;
  if (cached) return cached;
  try { L.info('media:gate', 'makeTransportGate.entered'); } catch {}
  const transportGatePrevRef: MutableRefObject<number> = { current: 1 } as any;
  // Persist desired gate open/closed state across graph rebuilds
  const anyRefs: any = refs as any;
  if (anyRefs._gateState == null) anyRefs._gateState = 1; // 1=open, 0=closed

  function closeTransportGate() {
    try { L.info('media:gate', 'close.entered'); } catch {}
    const gateNode: GainNode | undefined = refs.gateGainRef?.current ?? refs.masterGainRef?.current ?? undefined;
    const g = gateNode?.gain;
    const ctx = refs.audioCtxRef.current;
    if (!g) return;
  try { transportGatePrevRef.current = g.value; } catch {}
  try { anyRefs._gateState = 0; } catch {}
  try { L.info('media:gate', 'close', { gid: tagNode(gateNode), prev: transportGatePrevRef.current, ctxTime: ctx?.currentTime }); } catch {}
    if (ctx) {
      const now = ctx.currentTime;
      try { g.cancelScheduledValues(now); g.setValueAtTime(0, now); } catch {}
    } else {
      try { (g as any).value = 0; } catch {}
    }
  }

  function openTransportGate(fadeMs = 50) {
    try { L.info('media:gate', 'open.entered', { fadeMs }); } catch {}
    const gateNode: GainNode | undefined = refs.gateGainRef?.current ?? refs.masterGainRef?.current ?? undefined;
    const g = gateNode?.gain;
    const ctx = refs.audioCtxRef.current;
  // Clamp to [0, maxOpen] to allow boosts above unity; maxOpen corresponds to +6 dB (~1.995x)
    const prevTarget = (anyRefs._gatePrevTarget ?? transportGatePrevRef.current) as number;
  const maxOpen = Math.pow(10, 6 / 20);
    const target = Math.max(0, Math.min(maxOpen, prevTarget));
    if (!g) return;
  try { L.info('media:gate', 'open', { gid: tagNode(gateNode), target, fadeMs, ctxTime: ctx?.currentTime }); } catch {}
    if (ctx) {
      const now = ctx.currentTime;
      try {
        g.cancelScheduledValues(now);
        if (fadeMs <= 0) {
          g.setValueAtTime(target, now);
        } else {
          // Start the ramp from the current (or a tiny) value to avoid a flat line before the ramp
          const startVal = Math.max(0.0001, (g as any).value ?? 0);
          g.setValueAtTime(startVal, now);
          g.linearRampToValueAtTime(target, now + fadeMs / 1000);
        }
      } catch {}
    } else {
      try { (g as any).value = target; } catch {}
    }
    try { anyRefs._gateState = 1; } catch {}
  }

  const fns = { closeTransportGate, openTransportGate };
  try { (refs as any)._gateFns = fns; } catch {}
  return fns;
}
